import { type SelectedEnergyTypes } from "../types/selectedEnergyTypes"

export function isDualEnergy(selectedEnergyTypes: SelectedEnergyTypes) {
    return selectedEnergyTypes.length === 2
}
